export {default} from './TextLink.js';



// WEBPACK FOOTER //
// ./~/wix-style-react/src/BaseComponents/TextLink/index.js